var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProbabilityHail01 = function SvgProbabilityHail01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 631.96 500.84",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 19.37,
    y1: 278.14,
    x2: 446.37,
    y2: -19.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 68.41,
    y1: 348.41,
    x2: 495.41,
    y2: 50.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -23.59,
    y1: 216.59,
    x2: 403.41,
    y2: -81.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 167.04,
    y1: 489.74,
    x2: 594.04,
    y2: 191.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 252.39,
    y1: 612.03,
    x2: 679.39,
    y2: 314.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 140.2,
    y1: 451.28,
    x2: 567.2,
    y2: 153.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 223.47,
    y1: 570.59,
    x2: 650.47,
    y2: 272.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 142.14,
    y1: 454.06,
    x2: 569.14,
    y2: 156.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 156.73,
    y1: 474.96,
    x2: 583.73,
    y2: 176.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 267.53,
    y1: 633.73,
    x2: 694.53,
    y2: 335.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 242.2,
    y1: 597.43,
    x2: 669.2,
    y2: 299.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 204.49,
    y1: 543.39,
    x2: 631.49,
    y2: 245.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 211.06,
    y1: 552.81,
    x2: 638.06,
    y2: 254.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 186.97,
    y1: 518.29,
    x2: 613.97,
    y2: 220.29,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M171.78,0C76.91,0,0,76.91,0,171.78s76.91,171.78,171.78,171.78,171.78-76.91,171.78-171.78S266.65,0,171.78,0ZM75.39,143.18c-4.1-6.8-6.15-14.4-6.15-22.8s2.07-16.3,6.23-23.1c4.15-6.8,9.65-12.15,16.5-16.05,6.85-3.9,14.32-5.85,22.42-5.85s15.7,2,22.5,6c6.8,4,12.23,9.4,16.27,16.2,4.05,6.8,6.08,14.4,6.08,22.8s-2.08,16.15-6.23,22.95c-4.15,6.8-9.63,12.15-16.42,16.05-6.8,3.9-14.2,5.85-22.2,5.85s-15.73-1.97-22.57-5.92c-6.85-3.95-12.33-9.32-16.43-16.13ZM130.89,284.18h-42.3l121.2-210h42.3l-121.2,210ZM265.36,260.78c-4.05,6.8-9.5,12.23-16.35,16.28-6.85,4.05-14.43,6.08-22.73,6.08s-15.85-2.07-22.65-6.23c-6.8-4.15-12.2-9.65-16.2-16.5-4-6.85-6-14.22-6-22.12,0-8.6,2.07-16.3,6.22-23.1,4.15-6.8,9.65-12.17,16.5-16.12,6.85-3.95,14.22-5.92,22.12-5.92,8.6,0,16.3,2.1,23.1,6.3,6.8,4.2,12.17,9.73,16.12,16.58,3.95,6.85,5.93,14.28,5.93,22.27s-2.03,15.7-6.08,22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.29,218.18c-5.4,0-10.05,1.95-13.95,5.85-3.9,3.9-5.85,8.65-5.85,14.25s1.95,10.05,5.85,13.95c3.9,3.9,8.55,5.85,13.95,5.85s10.35-1.95,14.25-5.85c3.9-3.9,5.85-8.55,5.85-13.95s-1.95-10.35-5.85-14.25c-3.9-3.9-8.65-5.85-14.25-5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.39,140.18c5.4,0,10.05-1.92,13.95-5.77,3.9-3.85,5.85-8.52,5.85-14.02s-1.95-10.3-5.85-14.1c-3.9-3.8-8.55-5.7-13.95-5.7s-10.23,1.9-14.17,5.7c-3.95,3.8-5.93,8.5-5.93,14.1s1.97,10.18,5.93,14.02c3.95,3.85,8.67,5.77,14.17,5.77Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M288.57,420.28c2.12,0,4.14-.97,5.46-2.63l30.18-37.81c2.41-3.02,1.91-7.41-1.1-9.82-3.02-2.41-7.41-1.91-9.82,1.1l-30.18,37.81c-1.67,2.1-2,4.97-.83,7.39,1.16,2.42,3.61,3.96,6.29,3.96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M581.08,372.36c-3.02-2.41-7.41-1.91-9.82,1.1l-28.3,35.46c-2.41,3.01-1.91,7.41,1.1,9.82,3.02,2.4,7.41,1.91,9.82-1.1l28.31-35.46c2.4-3.02,1.91-7.41-1.1-9.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M271.83,347.22c-2.51-.36-5.01.66-6.55,2.67l-21.36,26.76c-1.62,1.94-2.07,4.61-1.16,6.97.9,2.36,3.02,4.05,5.52,4.41,2.5.36,5.01-.66,6.54-2.67l21.37-26.76c1.62-1.94,2.06-4.61,1.16-6.97-.91-2.36-3.02-4.05-5.52-4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M516.11,388c11.96,0,21.65-9.69,21.65-21.65s-9.69-21.65-21.65-21.65-21.65,9.69-21.65,21.65c.02,11.95,9.7,21.63,21.65,21.65ZM516.11,358.68c4.24,0,7.68,3.44,7.68,7.68s-3.44,7.68-7.68,7.68-7.68-3.44-7.68-7.68c0-4.24,3.44-7.67,7.68-7.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M621.46,215.31c-14-24.11-39.84-38.87-67.72-38.67-9.07-.01-18.06,1.59-26.56,4.74-13.4-39.99-47.75-69.35-89.34-76.36-32.72-5.52-65.74,3.5-90.88,23.86,2.22,4.27,4.23,8.66,6.02,13.16,22.39-19.49,52.71-28.39,82.84-23.2,38.84,6.68,70.17,35.49,80.07,73.64,3.22,15.98,2.7,32.49-1.52,48.23-1.17,3.64.81,7.54,4.43,8.76,3.63,1.22,7.55-.71,8.82-4.32,4.59-16.26,5.59-33.33,2.9-50.01,7.38-2.97,15.26-4.51,23.22-4.53,22.87-.18,44.09,11.92,55.58,31.7,11.49,19.78,11.49,44.2,0,63.98-11.49,19.78-32.7,31.88-55.58,31.7h0s-262.09,0-262.09,0c-10.39,6-21.61,10.73-33.44,13.97h295.54c27.88.2,53.72-14.56,67.72-38.67,14-24.11,14-53.87,0-77.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M223.62,400.97c-15.08,0-27.31,12.22-27.31,27.31,0,15.08,12.24,27.31,27.32,27.3,15.08,0,27.3-12.24,27.3-27.32-.03-15.07-12.24-27.27-27.3-27.29ZM223.62,441.61h0c-7.36,0-13.33-5.96-13.34-13.32,0-7.36,5.96-13.34,13.32-13.35,7.36,0,13.34,5.95,13.35,13.32,0,7.37-5.97,13.34-13.33,13.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M511.24,436.35c-15.08,0-27.3,12.22-27.3,27.3s12.22,27.3,27.3,27.3,27.3-12.22,27.3-27.3c-.02-15.07-12.23-27.29-27.3-27.3ZM511.24,476.99c-7.36,0-13.33-5.97-13.33-13.33s5.97-13.33,13.33-13.33,13.33,5.97,13.33,13.33c0,7.36-5.97,13.33-13.33,13.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M495.27,398.48c-3.02-2.41-7.41-1.91-9.82,1.1l-71.77,89.9c-2.4,3.02-1.91,7.41,1.1,9.82,3.02,2.41,7.41,1.91,9.82-1.1l71.77-89.91c2.4-3.02,1.91-7.41-1.1-9.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M318.75,430.68c-18.21,0-32.96,14.76-32.97,32.96,0,18.21,14.76,32.97,32.96,32.97s32.96-14.76,32.97-32.96c-.02-18.2-14.77-32.95-32.96-32.97ZM318.75,482.65c-10.49,0-19-8.51-19-18.99s8.51-18.99,19-18.99,18.99,8.5,18.99,18.99c-.01,10.49-8.51,18.98-18.99,18.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M471.09,358.61c2.4-3.01,1.91-7.41-1.1-9.82-3.02-2.4-7.41-1.91-9.82,1.1l-75.31,94.33c-2.41,3.02-1.92,7.41,1.1,9.83,3.02,2.41,7.41,1.92,9.83-1.1l75.31-94.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M399.56,366.85c2.41-3.02,1.91-7.41-1.1-9.82-3.02-2.41-7.41-1.91-9.82,1.1l-40.55,50.81c-2.41,3.01-1.91,7.41,1.1,9.82,3.01,2.41,7.41,1.91,9.82-1.1l40.56-50.8h0Z"
  }))));
};
export default SvgProbabilityHail01;